import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notes-index',
  templateUrl: './notes-index.component.html',
  styleUrls: ['./notes-index.component.scss']
})
export class NotesIndexComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
